export enum MailType {
    Customer = "orderConfirmationEmail", 
    Owner = "newOrderEmail",
    Message = "notificationEmail",
    OrderUpdate = "orderStatusEmail",
    Signup = "signupEmail"
}